<header aria-label="Main site header">
  <p-header
    [env]="env.env"
    [locale]="env.locale"
    mode="hero"
  ></p-header>
</header>

<main>
  <ng-container
    *ngIf="hasValidUrlParameters$ | async; else invalidLinkTemplate"
  >
    <ng-container
      *ngIf="
        (listUnsubscribed$ | async) || (isUnsubscribed$ | async);
        else landingPageTemplate
      "
    >
      <app-unsubscribed-newsletter></app-unsubscribed-newsletter>
    </ng-container>

    <ng-template #landingPageTemplate>
      <app-unsubscribe-newsletter></app-unsubscribe-newsletter>
    </ng-template>
  </ng-container>

  <ng-template #invalidLinkTemplate>
    <section
      class="unsubscribe-error__container"
      aria-label="Invalid unsubscribe link"
      lang="en"
    >
      <p-inline-notification
        state="error"
        heading="This unsubscribe link isn’t valid."
        headingTag="h1"
        [dismissButton]="false"
        description="This link is incomplete or invalid. Please use the unsubscribe link provided in the original message. No unsubscribe request has been submitted."
      ></p-inline-notification>
    </section>
  </ng-template>
</main>

<pnav-footer
  [env]="env.env"
  [locale]="env.locale"
  [displayOptions]="{ scroller: false }"
></pnav-footer>